import React, { useState } from "react";
import { toast } from "react-toastify";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import { AiFillLinkedin, AiFillInstagram, AiFillGithub, AiFillFacebook } from "react-icons/ai";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://imaliazzeddine.com/send_email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        toast.success("Message sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        toast.error("Failed to send message. Please try again.");
      }
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("An error occurred. Please try again later.");
    }
  };

  return (
    <section id="contact" className="text-gray-600 body-font bg-gray-100 py-10">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Title */}
        <div className="flex flex-col text-center w-full mb-10">
          <h1 className="sm:text-4xl text-3xl font-medium title-font text-black mb-2">
            Contact Me
          </h1>
          <p className="text-lg text-dark-orange">
            Have a question or want to work together? Let’s connect.
          </p>
        </div>

        {/* Contact Section */}
        <div className="flex flex-col lg:flex-row bg-white shadow-lg rounded-lg">
          {/* Contact Info */}
          <div className="bg-darkblue text-white lg:w-1/2 flex flex-col justify-center px-6 py-8 lg:px-10 lg:py-12">
            <h2 className="text-2xl font-bold mb-6">Get In Touch</h2>
            <div className="flex items-center gap-4 mb-6">
              <FaPhoneAlt className="text-lg" />
              <p className="text-lg">+212 6 48 90 95 09</p>
            </div>
            <div className="flex items-center gap-4 mb-6">
              <FaEnvelope className="text-lg" />
              <a
                href="mailto:imaliazedin@gmail.com"
                className="text-lg underline hover:text-orange-500"
              >
                imaliazedin@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-4">
              <FaMapMarkerAlt className="text-lg" />
              <p className="text-lg">Rabat-Salé-Kénitra, Morocco</p>
            </div>
            <div className="mt-8 flex gap-6 justify-center lg:justify-start">
              <a
                href="https://www.linkedin.com/in/imaliazzeddine/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-2xl hover:text-blue-500"
              >
                <AiFillLinkedin />
              </a>
              <a
                href="https://github.com/azedin"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-2xl hover:text-gray-400"
              >
                <AiFillGithub />
              </a>
              <a
                href="https://www.instagram.com/im1zdn_/profilecard/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-2xl hover:text-pink-500"
              >
                <AiFillInstagram />
              </a>
              <a
                href="https://www.facebook.com/share/1Xf8wwX1Sa/?mibextid=LQQJ4d"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white text-2xl hover:text-blue-700"
              >
                <AiFillFacebook />
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <form
            onSubmit={handleSubmit}
            className="lg:w-1/2 bg-white px-8 py-8 lg:px-12 lg:py-12"
          >
            <h2 className="text-2xl font-bold text-gray-800 mb-6">
              Send Me a Message
            </h2>
            <div className="mb-4">
              <label htmlFor="name" className="block text-gray-700 font-medium">
                Name
              </label>
              <input
                required
                type="text"
                name="name"
                id="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:border-dark-orange focus:ring-1 focus:ring-dark-orange"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="email" className="block text-gray-700 font-medium">
                Email
              </label>
              <input
                required
                type="email"
                name="email"
                id="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:border-dark-orange focus:ring-1 focus:ring-dark-orange"
              />
            </div>
            <div className="mb-6">
              <label htmlFor="message" className="block text-gray-700 font-medium">
                Message
              </label>
              <textarea
                required
                name="message"
                id="message"
                rows="5"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                className="w-full border border-gray-300 rounded-lg p-3 mt-1 focus:outline-none focus:border-dark-orange focus:ring-1 focus:ring-dark-orange"
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-dark-orange text-white py-3 rounded-lg font-medium hover:bg-orange-600 transition duration-300"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
